import { createQueryKeys } from '@lukemorales/query-key-factory';

import { fetchWorkflowDefinitionVariantMetrics } from '@/domains/workflow-definitions/workflow-definitions-metrics/workflow-definitions-metrics.api';

export const workflowDefinitionMetricKeys = createQueryKeys('workflow-definitions-metrics', {
  workflowDefinitionVariantMetrics: () => ({
    queryKey: [{}],
    queryFn: () => fetchWorkflowDefinitionVariantMetrics(),
  }),
});
